module.exports = __webpack_public_path__ + "img/92ne.379300d7.svg";